module.exports = __webpack_public_path__ + "img/booster_help_text_1.dc3a695f.svg";